module.exports = __webpack_public_path__ + "static/media/sort.6ddc9b6d.svg";